import { ShipmentStatus } from '#/shared/api/generated/shipment/models'
import type { ShipmentDetail } from '#/shared/api/generated/shipment/models'

const TRACKING_STATUSES = new Set<string>([
  ShipmentStatus.dispatched,
  ShipmentStatus.picked_up,
])

export function shouldShowTracking(
  shipment: ShipmentDetail | undefined,
): boolean {
  if (!shipment) return false
  return TRACKING_STATUSES.has(shipment.status)
}
